import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { RQAPICallWithData } from 'store/APIClient';
import { DECISION, ModuleT } from 'business/constants';
import { UserInfoWithIdT } from 'business/definitions';

/**
 * Hook React Query to fetch the list of suggested users for a given module
 * @param {ModuleT} module - The module for which the suggested users are fetched
 */
export const useGetSuggestedUsers = (
    module: ModuleT,
    enabled: boolean = true,
    allUsers: boolean = false,
): UseQueryResult<UserInfoWithIdT[]> => {
    const { slug } = useParams<{ slug: string }>();
    return useQuery({
        queryKey: ['auth/suggested_users', module, slug, allUsers],

        queryFn: async () => {
            const response = await RQAPICallWithData<UserInfoWithIdT>({
                endpoint:
                    module === DECISION && slug
                        ? `auth/suggested_users/${module}?dashboard_slug=${slug}&all_users=${allUsers}`
                        : `auth/suggested_users/${module}?all_users=${allUsers}`,
                method: 'GET',
            });
            return response.content.data;
        },

        enabled,
    });
};
